import {Injectable} from '@angular/core';
import {Http, RequestOptions, URLSearchParams, Headers, ResponseContentType} from '@angular/http';
import 'rxjs/add/operator/map';

import {SettingsProvider} from '../settings';
import {LoaderProvider} from "../loader";
import {AlertService} from '../util/alert.service';
import {Events, NavController} from "ionic-angular";
import {ConstantProvider} from "../constants";

@Injectable()
export class ApiProvider {

  url: string;
  urlJ: string;
  token: string = '';
  request: any;

  constructor(public http: Http,
              public settings: SettingsProvider,
              public events: Events,
              public loader: LoaderProvider,
              public alert: AlertService, public constants: ConstantProvider) {

    this.url = this.constants.API_URL;
    this.urlJ = this.constants.API_URL_JAVA;

  }

  obter(endpoint: string, params?: any, options?: RequestOptions) {
    return new Promise((resolve, reject) => {
      this.pget(endpoint, params, options).then((res: any) => {
        if (res != undefined) {
          if (res.data) {
            resolve(res.data)
          } else {
            resolve(res)
          }
        }
      }, (error: any) => {
        this.loader.hide();
        this.callLogout(error.status);
      });
    });
  }

  pget(endpoint: string, params?: any, options?: RequestOptions) {
    return new Promise((resolve, reject) => {
      this.settings.loadSetting('session')
        .then((res: any) => {
          if (!options) {
            options = new RequestOptions();
          }
          if (res == undefined) {
            return [];
          }
          options.headers = new Headers();
          options.headers.append('Authorization', 'Bearer ' + res.token);
          if (params) {
            let p = new URLSearchParams();
            for (let k in params) {
              p.set(k, params[k]);
            }
            options.search = !options.search && p || options.search;
          }
          ;
          this.request = this.http
            .get(this.url + '/' + endpoint, options)
            .subscribe(
              (res: any) => {
                let resp = res.json();
                if (resp.logout) {
                  this.events.publish('reload:fnLogout');
                } else {
                  resolve(res.json())
                }
              },
              (error: any) => {
                this.loader.hide();
                this.callLogout(error.status);
              }
            );
          return this.request;
        });
    });
  }

  callLogout(httpCode) {
    this.loader.show();
    if (httpCode == 401) {
      this.events.publish('reload:fnLogout', []);
    }
  }

  cancelRequest() {
    if (this.request != undefined) {
      this.request.unsubscribe();
    }
  }

  post(endpoint: string, body: any, options?: RequestOptions) {
    return new Promise(resolve => {
      this.settings.loadSetting('session')
        .then((res: any) => {
          if (!options) {
            options = new RequestOptions();
          }
          if (res == undefined) {
            return [];
          }
          options.headers = new Headers();
          options.headers.append('Authorization', 'Bearer ' + res.token);

          this.request = this.http.post(this.url + '/' + endpoint, body, options)
            .subscribe(res => {
              let resp = res.json();
              if (resp.logout) {
                this.events.publish('reload:fnLogout');
              } else {
                resolve(res.json())
              }
            }, (error: any) => {
              this.loader.hide();
              this.callLogout(error.status);
            });
          return this.request;
        });
    });
  }

  put(endpoint: string, body: any, options?: RequestOptions) {
    return new Promise(resolve => {
      this.settings.loadSetting('session')
        .then((res: any) => {
          if (!options) {
            options = new RequestOptions();
          }
          if (res == undefined) {
            return [];
          }
          options.headers = new Headers();
          options.headers.append('Authorization', 'Bearer ' + res.token);

          this.request = this.http.put(this.url + '/' + endpoint, body, options)
            .subscribe(res => {
              let resp = res.json();
              if (resp.logout) {
                this.events.publish('reload:fnLogout');
              } else {
                resolve(res.json())
              }
            }, (error: any) => {
              this.loader.hide();
              this.callLogout(error.status);
            });
          return this.request;
        });
    });
  }

  delete(endpoint: string, body: any, options?: RequestOptions) {
    return new Promise(resolve => {
      this.settings.loadSetting('session')
        .then((res: any) => {
          if (!options) {
            options = new RequestOptions();
          }
          if (res == undefined) {
            return [];
          }
          options.headers = new Headers();
          options.headers.append('Authorization', 'Bearer ' + res.token);

          this.request = this.http.delete(this.url + '/' + endpoint, options)
            .subscribe(res => {
              let resp = res.json();
              if (resp.logout) {
                this.events.publish('reload:fnLogout');
              } else {
                resolve(res.json())
              }
            }, (error: any) => {
              this.loader.hide();
              this.callLogout(error.status);
            });
          return this.request;
        });
    });
  }

  MessageErroRequest(objErro) {
    this.alert.presentAlert("Erro", objErro.status + " -> " + objErro.statusText);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts